module.exports = __webpack_public_path__ + "static/media/uanalytics-tick.159e641f.svg";